import { Box, Typography, Divider } from "@mui/material";
import parse from "html-react-parser";
import moment from "moment";

import { ExpandedEcrAssignmentRow } from "api/memberPortal/reports/expandedEcrAssignment/expandedEcrAssignment.types";

const NotesCell = ({
  row: { latest_note },
}: {
  row: ExpandedEcrAssignmentRow;
}) => {
  if (!latest_note) {
    // WARN: Custom styling from pre standardization!
    // TODO: Standardize when you come across this!
    return (
      <Typography
        variant="caption"
        sx={{
          fontStyle: "italic",
          color: "text.disabled",
        }}
      >
        No notes available
      </Typography>
    );
  }
  return (
    <Box sx={{ py: 1 }}>
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography
        variant="caption"
        sx={{
          fontStyle: "italic",
          color: "text.secondary",
          mb: 1,
          lineHeight: 1.4,
        }}
      >
        {parse(latest_note.note)}
      </Typography>
      <Divider sx={{ my: 1 }} />
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography
        variant="caption"
        sx={{
          color: "text.disabled",
          fontStyle: "italic",
        }}
      >
        Submitted on{" "}
        {moment.utc(latest_note.submitted_on).format("YYYY.MM.DD [at] HHmm")} by{" "}
        {latest_note.submitted_by}
      </Typography>
    </Box>
  );
};

export default NotesCell;
